export const POWERED_BY_LINK = "https://www.wizenai.com/";
export const POWERED_BY_TEXT = "Wizen";

/**
 * Safe local fallback while `/v2/widget-config` is unavailable. Tenant config
 * is the normal disclaimer source and replaces this bootstrap value when it
 * resolves. This must stay identical to the API's canonical default.
 */
export const DEFAULT_DISCLAIMER_TEXT
  = "This AI tool generates responses that may be inaccurate. Please verify important information.";

// UTM tagging for the "Powered by Wizen" attribution link. utm_source is
// per-tenant (organizationSlug from /v2/widget-config); the rest are static.
export const POWERED_BY_UTM_MEDIUM = "embedded-widget";
export const POWERED_BY_UTM_CAMPAIGN = "Wizen";
export const POWERED_BY_UTM_CONTENT = "widget-home";

export const buildPoweredByUrl = (organizationSlug?: string): string => {
  if (!organizationSlug) {
    return POWERED_BY_LINK;
  }
  const url = new URL(POWERED_BY_LINK);
  url.searchParams.set("utm_source", organizationSlug);
  url.searchParams.set("utm_medium", POWERED_BY_UTM_MEDIUM);
  url.searchParams.set("utm_campaign", POWERED_BY_UTM_CAMPAIGN);
  url.searchParams.set("utm_content", POWERED_BY_UTM_CONTENT);
  return url.toString();
};
